module.exports = __webpack_public_path__ + "img/prizes.664ead73.png";